<template>
	<div class="max-w-[853px] mx-auto">
<!--		<span v-if="!inRelation" class="font-semibold text-[20px] xl:text-[24px]">Sonda {{ hasPollEnded ? '(zakończona)' : '' }}</span>-->
		<div :class="{'!bg-zt-light/30 !font-medium border-zt-light/60 border !text-sm px-[11px] xl:!px-[18px] xl:!py-2.5 xl:!text-base' : inRelation}"
          class="bg-[#313D51] mt-[9px] py-4 px-2.5 rounded-zt text-[16px] xl:text-base xl:mt-[13px] xl:px-10 xl:py-4">
			<div  class="pb-2 xl:pb-4 xl:mx-6"
           :class="{ 'xl:!pb-2.5 xl:!mx-0' : inRelation }">
				<span class="font-[500]">SONDA: {{ pollData.title }} {{ hasPollEnded ? '(zakończona)' : '' }}</span>
			</div>
			<div class="flex flex-col gap-y-[6px] xl:gap-y-[11px] xl:mx-6"
           :class="{ 'xl:!mx-0' : inRelation }">
        <div v-for="(option, index) in pollOptions" :key="option.id"
             :class="{ 'cursor-pointer zt-hover' : canUserVote, 'progress-selected' : option.id === selectedId || hasPollEnded,
                       'progress after:!bg-[#3A4B64]' : !canUserVote && option.id !== selectedId && !hasPollEnded, '!py-[5px] xl:!py-[10px]' :inRelation }"
             :style="`--div-width: ${getWidthPercentage(option)}% `"
             class="w-full transition-all group flex gap-x-[18px] py-2.5 font-[500] border-2 border-[#415876] rounded-zt xl:py-[15px]"
             @click="selectOption(option.id, index)">
					<div class="z-10 flex items-center mr-2" :class="hasPollEnded ? '-ml-2.5 xl:pl-[6px] xl:-ml-0' : 'w-[15px] pl-[9px] xl:w-[36px] xl:pl-[18px]'">
            <svg v-if="option.id === selectedId && !hasPollEnded" class="shrink-0"
                xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
              <rect x="0.5" y="0.5" width="24" height="24" rx="12" fill="" :class="selectedId === option.id ? 'stroke-[#9B2733] fill-zt-red' : 'stroke-[#9B2733]'"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.3918 15.9467L5.30986 12.235L3.94922 13.4723L9.3918 18.4212L21.0545 7.81634L19.6938 6.5791L9.3918 15.9467Z" fill="white"/>
            </svg>
            <svg v-else-if="!hasPollEnded" class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
              <rect x="0.5" y="0.5" width="24" height="24" rx="12" fill="#313D51"/>
              <rect x="0.5" y="0.5" width="24" height="24" rx="12" stroke="#485C7A"/>
            </svg>
					</div>
					<div class="w-full z-10 flex gap-x-5 justify-between">
						<span>{{ option.title }}</span>
            <Transition name="slide-fade">
              <div v-if="!canUserVote" class="flex gap-x-[7px] items-center">
<!--                <span class="only-desktop text-sm font-medium text-zt-more">-->
<!--                  ({{ option.votes }})-->
<!--                </span>-->
                <span class="pr-5">
                  {{ sumOfVotes > 0 ? getWidthPercentage(option) : "0" }}%
                </span>
              </div>
            </Transition>
					</div>
				</div>
			</div>
      <div v-if="!canUserVote" class="text-center pt-4 flex justify-between xl:mx-6">
        <span class="text-sm">
          Zagłosowało: <span class="font-semibold">{{ sumOfVotes }}</span>
        </span>
        <span class="text-zt-red underline zt-hover cursor-pointer text-sm"
              @click.stop="$emit('refresh')" :class="{'pointer-events-none opacity-50' : hasPollEnded}">
          Odśwież
        </span>
      </div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SinglePoll',
	inject: ['WP'],
	props: ['pollData', 'pollOptions'],
	data() {
		return {
			selectedId: 0,
			canUserVote: true,
		}
	},
  computed: {
    sumOfVotes() {
      return Object.values(this.pollOptions).reduce((t, {votes}) => t + +votes, 0);
    },
    hasPollEnded() {
      if (this.pollData.end_date) {
        const pollEndDate = DateTime.fromSQL(this.pollData.end_date).ts;
        const currentTime = DateTime.now().ts;
        return currentTime > pollEndDate;
      }
      return false;
    },
    inRelation() {
      return this.pollData.in_relation === '1';
    }
  },
	created() {
		this.checkCanUserVote();
		let interval = setInterval(() => {
			if (this.hasPollEnded) {
				this.canUserVote = false;
				clearInterval(interval);
			}
		}, 1000);
	},
	methods: {
		selectOption(option, index) {
			this.checkCanUserVote();
			if (!this.canUserVote) {
				return;
			}
			this.selectedId = option;
			axios
				.post(this.WP.ajaxUrl, {
					endpoint: 'api_add_user_poll_vote',
					poll_id: this.pollData.id,
					option_id: option,
          commentary_id: this.pollData.postId,
				})
				.then(() => {
					this.pollOptions[index].votes = +this.pollOptions[index].votes + 1;
					this.canUserVote = false;
				});
		},
		checkCanUserVote() {
			if (this.hasPollEnded) {
				this.canUserVote = false;
				return;
			}
			axios
				.post(this.WP.ajaxUrl, {
					endpoint: 'api_can_user_vote_in_poll',
					poll_id: this.pollData.id
				})
				.then((response) => {
					if (response.data.data !== true) {
						this.canUserVote = false;
						this.selectedId = response.data.data;
					}
				})
		},
		getWidthPercentage(option) {
			return Math.round((+option.votes / this.sumOfVotes) * 100);
		},
	},
}
</script>

<style scoped>
.progress:after,
.progress-selected:after {
  content: '\A';
  position: absolute;
  background: #3A4B64;
  background-size: contain;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: var(--div-width);
}

.progress, .progress-selected {
  position: relative;
  @apply overflow-hidden
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

</style>